<head>

<script src="https://unpkg.com/vue"></script>
<script src="https://unpkg.com/vue-cal"></script>
<link href="https://unpkg.com/vue-cal/dist/vuecal.css" rel="stylesheet">
</head>
<template>
  <div class="row" style="display: flex; justify-content: center; margin-top: 10%">
    <div class="card shadow text-center mb-3 custom-card" style="width: 18rem; margin-left: 10px; margin: 0">
      <div class="card-body" @click="menu('EXERCICIO')">
        <h5 class="card-title">
          <img src="../../../assets/flexao.svg" class="rounded" alt="" id="imgFoto" style="flex: 1; object-fit: cover; max-width: 50px; max-height: 50px" />
        </h5>
        <p class="card-text">Cálculo Exercícios</p>
      </div>
    </div>
    <div class="card shadow text-center mb-3 custom-card" style="width: 18rem; margin-left: 10px">
      <div class="card-body" @click="menu('MEDIA')">
        <h5 class="card-title">
          <img src="../../../assets/barra.svg" class="rounded" alt="" id="imgFoto" style="flex: 1; object-fit: cover; max-width: 50px; max-height: 50px" />
        </h5>
        <p class="card-text">Cálculo Média</p>
      </div>
    </div>
    <div class="card shadow text-center mb-3 custom-card" style="width: 18rem; margin-left: 10px">
      <div class="card-body" @click="menu('SITUACAO')">
        <h5 class="card-title">
          <img src="../../../assets/abdominal.svg" class="rounded" alt="" id="imgFoto" style="flex: 1; object-fit: cover; max-width: 50px; max-height: 50px" />
        </h5>
        <p class="card-text">Cálculo Situação</p>
      </div>
    </div>
    <div class="card shadow text-center mb-3 custom-card" style="width: 18rem; margin-left: 10px">
      <div class="card-body" @click="menu('CONCEITO')">
        <h5 class="card-title">
          <img src="../../../assets/corrida.svg" class="rounded" alt="" id="imgFoto" style="flex: 1; object-fit: cover; max-width: 50px; max-height: 50px" />
        </h5>
        <p class="card-text">Cálculo Conceito</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageParametroTAF',
  components: {},

  setup() {
    return {};
  },
  data() {
    return {
      encontrado: false,
      dataPacientes: [],
      responseDadosMilitar: {},
    };
  },

  methods: {
    async menu(nomeMenu) {
      switch (nomeMenu) {
        case 'EXERCICIO':
          this.$router.push('listar-calculo-exercicio');
          break;
        case 'MEDIA':
          this.$router.push('listar-calculo-media');
          break;
        case 'SITUACAO':
          this.$router.push('listar-calculo-situacao');
          break;
        case 'CONCEITO':
          this.$router.push('listar-calculo-conceito');
          break;
      }
    },
  },
  created() {},
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.custom-card {
  transition: border 0.3;
  /* Adiciona uma transição suave para a mudança de borda */
  cursor: pointer;
}

.custom-card:hover {
  border: 2px solid #007bff;
  /* Cor e espessura da borda no hover */
}
</style>
